import { PantryLocation, PANTRY_LOCATIONS } from '../../utils/pantryLocation';

export interface ZoneIconRef { lib: 'mci'; name: string }

export const ZONE_KEYS: PantryLocation[] = PANTRY_LOCATIONS; // fridge, freezer, counter, pantry

/** Zone identity: label + condition line + object icon (gm-final.jsx:15-21). */
export const ZONE_META: Record<PantryLocation, { labelKey: string; condKey: string; icon: ZoneIconRef }> = {
  fridge:  { labelKey: 'pantry.zones.fridge',  condKey: 'pantry.zoneCond.fridge',  icon: { lib: 'mci', name: 'fridge-outline' } },
  freezer: { labelKey: 'pantry.zones.freezer', condKey: 'pantry.zoneCond.freezer', icon: { lib: 'mci', name: 'snowflake' } },
  counter: { labelKey: 'pantry.zones.counter', condKey: 'pantry.zoneCond.counter', icon: { lib: 'mci', name: 'toaster-oven' } },
  pantry:  { labelKey: 'pantry.zones.pantry',  condKey: 'pantry.zoneCond.pantry',  icon: { lib: 'mci', name: 'cupboard-outline' } },
};
